
namespace RioERP.Products {

    @Serenity.Decorators.registerClass()
    export class ProductFranchiseeShareGrid extends Serenity.EntityGrid<ProductFranchiseeShareRow, any> {
        protected getColumnsKey() { return ProductFranchiseeShareColumns.columnsKey; }
        protected getDialogType() { return ProductFranchiseeShareDialog; }
        protected getIdProperty() { return ProductFranchiseeShareRow.idProperty; }
        protected getInsertPermission() { return ProductFranchiseeShareRow.insertPermission; }
        protected getLocalTextPrefix() { return ProductFranchiseeShareRow.localTextPrefix; }
        protected getService() { return ProductFranchiseeShareService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getButtons() {
            var buttons = super.getButtons();
            buttons.splice(1, 3);
           

            buttons.push(Common.ExcelExportHelper.createToolButton({
                grid: this,
                title: 'Export',
                service: ProductFranchiseeShareService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));
            
            buttons.push({
                title: 'Download FranchiseeShare Sample',
                cssClass: 'export-xlsx-button',
                onClick: () => {
                    debugger;
                    var url = "~/Products/FranchiseeShareImportSample";

                    Q.postToService({ url: Q.resolveUrl(url), request: '', target: '_blank' });
                }
            });
            buttons.push({
                title: 'Import From Excel',
                cssClass: 'export-xlsx-button',
                onClick: () => {
                    // open import dialog, let it handle rest
                    var dialog = new ProductFranchiseeShareImportDialog();
                    dialog.element.on('dialogclose', () => {
                        this.refresh();
                        dialog = null;
                    });
                    dialog.dialogOpen();
                }
            });
            return buttons;
        }
    }
}